<template>
      <TheFooter>
        <div></div>
        <div>
          <a href="http://www.pgsa.com.br">PGSA</a>
          <span class="ml-1">&copy; {{ year }}</span>
        </div>
        <!-- <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="https://coreui.io">CoreUI for Vue</a>
        </div> -->
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
